import { V2OpenRouterKeyResource } from "@generated";
import { OpenRouterKeyFormState } from "../types";

const formatOpenRouterKeyData = (
  formState: OpenRouterKeyFormState
): V2OpenRouterKeyResource => {
  // attributes is filled in by the switch below; initial cast keeps the
  // progressive construction type-compatible with the discriminated union.
  const resource = {
    type: "open-router-keys",
  } as V2OpenRouterKeyResource;

  if (formState.id) {
    resource.id = formState.id;
  }

  switch (formState.keyType) {
    case "azure":
      resource.attributes = {
        name: formState.name,
        llms: formState.llms as any,
        "key-type": "azure",
        "model-slug": formState.modelSlug,
        "endpoint-url": formState.endpointUrl,
        "api-key": formState.apiKey,
        "model-id": formState.modelId,
      };
      break;
    case "aws_bedrock":
      resource.attributes = {
        name: formState.name,
        llms: formState.llms as any,
        "key-type": "aws_bedrock",
        key: formState.key,
        "access-key-id": formState.accessKeyId,
        "secret-access-key": formState.secretAccessKey,
        region: formState.region,
      } as typeof resource.attributes;
      break;
    case "google_vertex":
      resource.attributes = {
        name: formState.name,
        llms: formState.llms as any,
        "key-type": "google_vertex",
        "model-type": formState.modelType,
        "project-id": formState.projectId,
        "private-key-id": formState.privateKeyId,
        "private-key": formState.privateKey,
        "client-email": formState.clientEmail,
        "client-id": formState.clientId,
        "auth-uri": formState.authUri,
        "token-uri": formState.tokenUri,
        "auth-provider-x509-cert-url": formState.authProviderX509CertUrl,
        "client-x509-cert-url": formState.clientX509CertUrl,
        "universe-domain": formState.universeDomain,
        region: formState.region,
      };
      break;
    case "other":
      resource.attributes = {
        name: formState.name,
        llms: formState.llms as any,
        "key-type": "other",
        key: formState.key,
      };
      break;
  }

  if (resource.attributes) {
    (resource.attributes as any).default = formState.default;
  }

  return resource;
};

export default formatOpenRouterKeyData;
